import React from 'react'

import GameLinkContainer from './components/GameLinkContainer'
import {
  H1,
} from '../styles'

const WaitingPrompt = ({players, player, game}) => {

  if (!player) {
    return <div>
      <H1>You're invited</H1>
      <p>To play Word Assassins, a game of real-life diabolical fun</p>
    </div>
  } else {
    return <div>
      <H1>Invite other players</H1>
      <GameLinkContainer game={game}/>
    </div>
  }

}

export default WaitingPrompt



// WEBPACK FOOTER //
// ./src/views/game/1_WaitingPrompt.jsx